module.exports = {
  customer: {
    customerId: "",
    primaryPhone: "",
    mobilePhone: "",
    homePhone: "",
    email: "",
    fullName: "",
  },

  vehicle: {
    vehicle_make: "Toyota",
    vehicle_model: "Tundra",
    vehicle_year: "2014",
    vehicle_vin: "5TFAW5F19EX759955",
    vehicle_color: "Black",
    vehicle_stock: "",
    reference_num: "",
    manual_flag: false,
  },

  repairOrder: {
    repair_order_number: "",
    vehicleId: "",
    customerId: "",
    total_labor_cost: 0,
    total_part_cost: 0,
    service_line_items_count: 0,
    labor_operations_count: 0,
    parts_count: 0,
    PO_number: "",
    transport_type: "",
  },

  //DMS config object (CDK)
  dms: {
    service: "CDK",
    props: {
      subscription_id: "test",
    },
  },

  //customer config object
  config: {
    version: "1.0.0",
    accessorials: {
      fuel: 0,
      tow: 0,
    },
    dms: {
      service: "CDK",
      props: {
        subscription_id: "test",
      },
    },
  },
};
